import React, { useEffect, useMemo, useState } from 'react';
import '../styles/Help.css';
import SupportDocs from './SupportDocs';
import { useTranslation } from '../context/TranslationContext';
import SupportVideos from './SupportVideos';
import Breadcrumb from './Breadcrumb';
import { useAuth } from '../context/AuthContext';
import FAQs from './FAQs';
import FAQsLegacy from './FAQsLegacy';
import { fetchFaqGroups } from '../helpers/contentfulHelper';
import { filterFaqGroupsByFlags } from '../helpers/faqSearch';
import { useFeatureFlags } from '../context/FeatureFlagsContext';
import Modal from './Modal';
import SupportForm from './SupportForm';
import SupportFormLegacy from './SupportFormLegacy';
import '../styles/Views.css';
import { useNavigate } from 'react-router-dom';

const Help = () => {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  const { features, ready } = useFeatureFlags();
  // New FAQ (search, videos, deep links) and Contact Support form; off keeps the PROD help page.
  const helpSupport = features?.helpSupport === true;
  const [allFaqs, setFaqs] = useState([]);
  const faqs = useMemo(() => {
    if (!ready) return [];
    const visible = filterFaqGroupsByFlags(allFaqs, features);
    // PROD listed groups by title only; the `order` field belongs to the new help page.
    return helpSupport
      ? visible
      : [...visible].sort((a, b) => (a.title || '').localeCompare(b.title || ''));
  }, [allFaqs, features, ready, helpSupport]);
  const FaqList = helpSupport ? FAQs : FAQsLegacy;
  const ContactForm = helpSupport ? SupportForm : SupportFormLegacy;

  useEffect(() => {
    const loadFaqs = async () => {
      const data = await fetchFaqGroups();
      setFaqs(data);
    };

    loadFaqs();
  }, []);

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="portal-page help-container">
      {isLoggedIn && (
        <div className="portal-page-breadcrumb">
          <Breadcrumb
            items={[
              { label: t('breadcrumb.home'), link: '/' },
              { label: t('breadcrumb.help') },
            ]}
          />
        </div>
      )}

      <header className="portal-page-header">
        <p className="portal-page-kicker">{t('breadcrumb.help')}</p>
        <h2 className="portal-page-title">{t('support_form_heading')}</h2>
        <p className="portal-page-subtitle">{t('help_subtitle')}</p>
      </header>

      <section className="portal-page-panel">
        <button
          className="portal-secondary-button"
          onClick={() => setIsSupportModalOpen(true)}
        >
          {t('support_form_heading')}
        </button>
      </section>

      <section className="portal-page-panel">
        <SupportDocs />
      </section>

      {faqs.length > 0 && (
        <section className="portal-page-panel">
          <FaqList faqs={faqs} />
        </section>
      )}

      <section className="portal-page-panel">
        <SupportVideos />
      </section>

      <Modal
        isOpen={isSupportModalOpen}
        onClose={() => setIsSupportModalOpen(false)}
      >
        <ContactForm />
      </Modal>

      <div onClick={handleBack} className="link mt-20 portal-page-footer-link">
        {t('back')}
      </div>
    </div>
  );
};

export default Help;
